import React from 'react';
import { Helmet } from 'react-helmet-async';
import './About.css';
import FadeInSection from './FadeInSection';
import getCanonicalUrl from '../utils/getCanonicalUrl';

const Access = () => {
  const canonicalUrl = getCanonicalUrl('https://gokurakuji-kinokawa.com/access');

  return (
    <div className="about-page">
      <Helmet>
        <title>アクセス | 安養山極楽寺</title>
        <meta
          name="description"
          content="安養山極楽寺へのアクセス情報。和歌山電鐵貴志川線「貴志駅」から徒歩15分、無料駐車場完備の寺院です。地図・交通手段をご確認ください。"
        />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="安養山極楽寺" />
        <meta property="og:title" content="アクセス | 安養山極楽寺" />
        <meta
          property="og:description"
          content="安養山極楽寺への行き方をご案内。貴志駅から徒歩圏内、車でも来訪しやすい寺院の地図情報です。"
        />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/slideshow2.jpeg`} />
        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <FadeInSection>
        <h2 className="section-title">アクセス</h2>
        <hr className="section-divider" />
      </FadeInSection>

      <FadeInSection>
        <section className="access-info">
          <p>〒640-0424　和歌山県紀の川市貴志川町井ノ口106</p>

          <h3>電車でお越しの方</h3>
          <p>和歌山電鐵貴志川線「貴志駅」より徒歩15分</p>

          <h3>お車でお越しの方</h3>
          <p>阪和道「和歌山南」ETC出口より20分</p>
          <p>無料駐車場あり</p>
        </section>
      </FadeInSection>

      <FadeInSection>
        <div className="map-embed" style={{ marginTop: '30px' }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3299.56429615454!2d135.3179317770325!3d34.20860720945537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6007367578536b11%3A0xd45296a073b2e390!2z5qW15qW95a-6!5e0!3m2!1sja!2sjp!4v1758360809400!5m2!1sja!2sjp"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>
      </FadeInSection>
    </div>
  );
};

export default Access;
